<template>
	<div>
		<!-- 消息通知 -->
		<el-dialog width="494px" :visible.sync="show" :append-to-body="true" @open="msgOpen()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="msg_dialog_box">
				<div class="msg_dialog_top_box">
					<div class="msg_dialog_top">
						<div class="msg_dialog_top_title">
							Notifications
						</div>
						<div class="msg_dialog_top_close">
							<img @click="close" class="msg_dialog_top_close_icon"
								src="../../../assets/icons/close_icon.png" alt="" />
						</div>
					</div>
					<div v-if="!detailShow" class="msg_dialog_wallet">
						<div class="msg_dialog_wallet_tab_box">
							<div class="msg_dialog_wallet_tab_item" v-for="(item,index) in msgTab" :key="item.id"
								@click="clickMsgType(item,index)"
								:class="index==msgType?'msg_dialog_wallet_tab_item_h':''">
								{{item.name}}
								<div class="red_dot" v-if="item.id==1&&msgNum.noticeUnReadNumber"></div>
								<div class="red_dot" v-if="item.id==2&&msgNum.activityUnReadNumber"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="msg_dialog_content_box" :class="detailShow?'mar_t20':''">
					<div class="msg_dialog_content" v-if="!detailShow" v-loading="loading">
						<div v-if="noticeList.length>0" class="msg_dialog_list_box">
							<div class="msg_dialog_list hide_scroll_bars">
								<div class="msg_dialog_list_item" v-for="(item,index) in noticeList" :key="item.noticeId"
									@click="clickNotItem(item,index)">
									<div class="msg_dialog_list_item_title">
										{{item.noticeTitle}}
									</div>
									<div class="msg_dialog_list_item_status">
										<span v-if="item.isRead" class="color_14EB74">READ</span>
										<span v-else class="">UNREAD</span>
									</div>
								</div>
							</div>
							<div class="mar_t10 flex_as_c">
								<el-pagination background layout="prev, pager, next" :page-size="params.pageSize"
									:total="total" @current-change="changePageNum">
								</el-pagination>
							</div>
						</div>

						<div v-else class="msg_dialog_msg_no">
							<img class="msg_dialog_msg_no_icon" src="../../../assets/icons/msg_no.png" alt="" />
							<div class="msg_dialog_msg_no_remark">
								Oops! You don’t have <br>
								any notifications yet
							</div>
						</div>
					</div>
					<div class="msg_dialog_content msg_dialog_content_detail" v-else>
						<div>
							{{convertUTCTime(curNot.createTime)}}
						</div>
						<div class="mar_t10">
							<div v-if="msgType==0">
								<div v-html="curNot.noticeContent"></div>
							</div>
							<div v-else>
								<el-carousel 
									:interval="0" 
									arrow="always" 
									indicator-position="none"
									height="240px"
									wight="100px"
									ref="carousel"
								>
									<el-carousel-item v-for="(item, index) in imgList" :key="index">
										<img class="vip_gift_content_item_lock_icon" :src="item" alt="" />
									</el-carousel-item>
								</el-carousel>
								<div style="margin-top: 20px;">{{curNot.activityContext}}</div>
							</div>
						</div>
					</div>
				</div>


			</div>
		</el-dialog>


	</div>
</template>

<script>
	import moment from'moment-timezone';
	import { mapState } from 'vuex';

	export default {
		name: 'referralDialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				loading: false,


				detailShow: false, //是否显示通知详情
				curNot: {},
				curIndex:'',
				msgType: 0, // 通知类型 1系统 2活动
				msgTab: [{
						id: 1,
						name: 'System Notice',
						api: 'getNoticeList',
						detApi: 'getNoticeDetails',
					},
					{
						id: 2,
						name: 'Activities',
						api: 'getActivityList',
						detApi: 'getActivityDetails',
					}
				],
				params: {
					pageNum: 1,
					pageSize: 10,
				},
				noticeList: [],
				total: 0,
				imgList: [],
				msgNum: { //未读消息数
					noticeUnReadNumber: 0,
					activityUnReadNumber: 0,
				}
			}
		},
		computed: {
			...mapState(['currentCountry']), // 映射 user 模块下的 userInfo 状态
		},
		methods: {
			// 根据不同时区转化时间
			convertUTCTime(utcTimestamp){
				// 获取用户本地时区偏移量（分钟）
				const utcMoment = moment.utc(utcTimestamp);
				const localMoment = utcMoment.tz(this.currentCountry.timezone);
				const formattedTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
				return formattedTime
			},
			close() {
				if (this.detailShow) {
					// 切换弹窗显示状态
					// 显示消息列表  清空消息详情
					this.detailShow = false
				} else {
					this.$emit('close', false)
				}
			},
			msgOpen() {
				this.getUnreadNumber()
				this.loading = true
				this.$api[this.msgTab[this.msgType].api](this.params).then(res => {
						res.rows.forEach(item => {
							if (this.msgType == 1) {
								item.noticeId = item.activityId
								item.noticeTitle = item.activityName
							}
						})
						this.noticeList = res.rows
						this.total = res.total
					})
					.finally(() => {
						this.loading = false
					})
			},
			clickMsgType(item, index) {
				this.noticeList = []
				this.params.pageNum = 1
				this.msgType = index
				this.msgOpen()
			},
			// 切换页面
			changePageNum(e) {
				this.params.pageNum = e
				this.msgOpen()
			},
			// 查看详情
			clickNotItem(item,index) {
				this.curIndex = index
				this.curNot = JSON.parse(JSON.stringify(item))
				this.detailShow = true
				this.getMsgDetail()
			},
			getMsgDetail() {
				let par = {}
				if (this.msgType == 0) {
					par = {noticeId: this.curNot.noticeId}
				} else {
					par = {activityId: this.curNot.activityId}
				}
				this.$api[this.msgTab[this.msgType].detApi](par).then(res => {
					this.getUnreadNumber()
					this.noticeList[this.curIndex].isRead = true
					if (this.msgType != 0) {
						this.imgList = res.data.activityImages.split(',');
					}
				})
			},
			// 获取未读消息数
			getUnreadNumber() {
				this.$api.getUnreadNumber({}).then(res => {
					this.msgNum = res.data
				})
			},





		},
	}
</script>

<style scoped lang="scss">
	/*对话框*/
	.msg_dialog_box {
		position: absolute;
		left: 0;
		top: 0;
		width: 494px;
		min-width: 494px;
		min-height: 454px;
		background: #1F242F;
		border-radius: 18px;
		overflow-y: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.msg_dialog_top_box {
		width: 494px;
		min-height: 70px;
		border-radius: 18px 18px 0 0;
	}

	.msg_dialog_top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 70px;
		color: #F0F0F0;
		font-size: 22px;
		background: #161A22;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.msg_dialog_top_title {}

	.msg_dialog_top_close {
		width: 43.38px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.msg_dialog_top_close_icon {
		width: 43.38px;
		height: 43.38px;
		cursor: pointer;
	}

	.msg_dialog_wallet {
		width: 100%;
		box-sizing: border-box;
		padding: 26px 23px 23px;
		background: #1F242F;
	}

	.msg_dialog_wallet_tab_box {
		display: flex;
		align-items: center;
	}

	.msg_dialog_wallet_tab_item {
		position: relative;
		width: 228px;
		height: 60px;
		background: #1F242F;
		box-shadow: inset 0px 16px 32px -8px rgba(12, 12, 13, 0.4);
		border-radius: 7px;
		border: 1px solid;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #A2B4D1;
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
	}

	.msg_dialog_wallet_tab_item_h {
		background: linear-gradient(180deg, rgba(25, 29, 38, 0) 0%, rgba(11, 44, 58, 0.6) 49%, rgba(15, 211, 77, 0.8) 100%);
		border-radius: 7px;
		border: 2px solid #14EB74;
		font-weight: bold;
		color: #FFFFFF;
		font-size: 18px;
	}

	.msg_dialog_content_box {
		flex: 1;
		width: 100%;
		box-sizing: border-box;
		padding: 0px 23px 23px;
	}

	.msg_dialog_content {
		min-height: 429px;
		background-color: #161A22;
		border-radius: 10px;
		box-sizing: border-box;
		padding: 10px;
	}

	.msg_dialog_list_box {
		width: 100%;
		height: 100%;
		min-height: 429px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.msg_dialog_list {
		width: 100%;
		flex: 1;
		box-sizing: border-box;
		padding: 10px;
		max-height: 500px;
		overflow-y: auto;
	}

	.msg_dialog_list_item {
		width: 100%;
		height: 50px;
		background: #161A22;
		border-radius: 8px;
		border: 1px solid #31394D;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 0 18px;
		margin-bottom: 16px;
		cursor: pointer;
	}

	.msg_dialog_list_item_title {
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		margin-right: 20px;
	}

	.msg_dialog_list_item_status {
		font-weight: 500;
		font-size: 18px;
		color: #FD002E;
	}


	.msg_dialog_content_detail {
		text-align: left;
		font-weight: 400;
		font-size: 15px;
		color: #B0C3E3;
		line-height: 17px;
	}

	.msg_dialog_msg_no {
		width: 100%;
		height: 429px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.msg_dialog_msg_no_icon {
		width: 237.36px;
		height: 212.06px;
	}

	.msg_dialog_msg_no_remark {
		margin-top: 50px;
		font-weight: 500;
		font-size: 17px;
		color: #A2B4D1;
	}
</style>